import React from "react";
import Button from "../../../components/ButtonUI";
import TextArea from "../../../components/TextArea";
import "./styles.scss";
import presentationSchema from "./schemas/presentationSchema";
import { addOrModifyDescription } from "../../../api/medecin";
import { Formik } from "formik";
import { User } from "../../../types/user";
import { userAtom } from "../../../state/auth";
import { useAtom } from "jotai";
import makeToast from "../../../components/Snackbar";
import { ReactComponent as Close } from "../../../assets/icons/icon-close.svg";

interface Props {
  openModal: boolean;
  setOpenModal: Function;
  doctorId?: string;
}

export const AddPresentation: React.FC<Props> = ({
  openModal,
  setOpenModal,
}) => {
  const [user, setUser] = useAtom(userAtom);

  return (
    <div className="fixed inset-0 z-50 outline-none focus:outline-none overflow-x-hidden overflow-y-auto bg-opacity-modal flexCenter">
      <div className="absolute bg-white z-40 top-0 left-0 w-full min-h-screen sm:top-1/3 sm:left-auto sm:w-1/2 sm:min-h-0 cursusAdd">
        <Formik
          initialValues={{
            description: "" || user?.description,
          }}
          onSubmit={async (values) => {
            try {
              const newUser = await addOrModifyDescription({ ...values });
              const { description } = newUser;

              setUser({
                ...user,
                description,
              } as User);
              setOpenModal(!openModal);
              if (newUser.id) {
                makeToast("success", "Présentation ajoutée avec succès.");
              } else {
                makeToast("error", "Présentation universitaire à échouher.");
              }
            } catch (err) {
              console.log("[error] add Patient -on Submit :", err);
            }
          }}
          validationSchema={presentationSchema}
        >
          {(props) => {
            const {
              values,
              errors,
              isSubmitting,
              handleChange,
              handleBlur,
              handleSubmit,
            } = props;

            return (
              <form
                onSubmit={handleSubmit}
                className="box-border w-full min-w-0 max-w-full py-7 px-4 sm:px-8"
              >
                <div className="flex flex-wrap items-baseline">
                  <h1 className="mb-10">Présentation</h1>
                </div>

                <div className="w-full min-w-0 max-w-full overflow-hidden">
                  <TextArea
                    id="description"
                    placeholder="Ecrivez votre description ..."
                    value={values.description}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    inlineLabel={false}
                    onfocus={true}
                    className="w-full min-w-0 max-w-full box-border"
                  />
                </div>

                <div className="flex w-full min-w-0 max-w-full items-center gap-3 overflow-hidden">
                  <Button
                    status="secondary"
                    width="100px"
                    height="50px"
                    className="flex-shrink-0 mb-4"
                    onClick={() => setOpenModal(false)}
                  >
                    Annuler
                  </Button>

                  <Button
                    status="secondary"
                    width="100px"
                    height="50px"
                    className="flex-shrink-0 mb-4"
                  >
                    Valider
                  </Button>
                </div>
              </form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default AddPresentation;
